import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

/**
 * Small amber-branded confirm dialog, drop-in replacement for every
 * `window.confirm()` call across the admin.
 *
 * Props:
 *  - open           : boolean, controlled
 *  - title          : string | ReactNode
 *  - body           : string | ReactNode (optional)
 *  - confirmLabel   : string (default "Confirm")
 *  - cancelLabel    : string (default "Cancel")
 *  - confirmColor   : MUI color ("error" for destructive, "primary" default)
 *  - onCancel       : () => void
 *  - onConfirm      : () => void
 *  - loading        : boolean — disables both buttons during async work
 */
const ConfirmDialog = ({
    open,
    title,
    body,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    confirmColor = "primary",
    onCancel,
    onConfirm,
    loading = false,
}) => (
    <Dialog open={!!open} onClose={loading ? undefined : onCancel} maxWidth="xs" fullWidth>
        {title && <DialogTitle sx={{ fontWeight: 700 }}>{title}</DialogTitle>}
        {body && (
            <DialogContent>
                <DialogContentText sx={{ color: "text.secondary" }}>{body}</DialogContentText>
            </DialogContent>
        )}
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
            <Button onClick={onCancel} disabled={loading} color="inherit">
                {cancelLabel}
            </Button>
            <Button
                onClick={onConfirm}
                variant="contained"
                color={confirmColor}
                disabled={loading}
                autoFocus
            >
                {confirmLabel}
            </Button>
        </DialogActions>
    </Dialog>
);

export default ConfirmDialog;
